import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { PopupContext } from "../../../context/PopupProvider";
import MyButton from "../../../components/MyButton";

const WithdrawMemberDialog = ({ onSubmit }) => {
  const { t } = useTranslation();
  const { closePopup } = useContext(PopupContext);

  const onDelete = () => {
    onSubmit();
    closePopup();
  };

  return (
    <div className="md:p-12 p-8 rounded-2xl bg-white">
      <p className="md:text-2xl text-xl font-medium text-center mb-1">
        계정을 비활성화하시겠습니까?
      </p>
      <p className="md:text-xl text-gray-dark text-center mb-6">
        이 작업은 되돌릴 수 없습니다. 계정을 비활성화하려면{" "}
        <b className="md:text-xl text-gray-dark font-semibold">확인</b>을
        클릭하십시오.
      </p>
      <div className="flex justify-center items-center gap-4">
        <MyButton onClick={closePopup}>{t("common.buttons.cancel")}</MyButton>
        <MyButton variant="contained" color="#e74c3c" onClick={onDelete}>
          확인
        </MyButton>
      </div>
    </div>
  );
};

export default WithdrawMemberDialog;
